import * as d3 from '../../scripts/lib/d3.js'
import getColor from './get_color.js'

riot.tag2('bullet', '', '', 'class="bullet" riot-style="left:{opts.data.value / 3}%;background-color:{fillColor};border-color:{strokeColor};" onclick="{onClick}" onmouseover="{onClick}"', function(opts) {

  this.fillColor = getColor(this.opts.data.value)
  this.strokeColor = d3.rgb(this.fillColor).darker(1)
  this.onClick = () => !this.opts.data.legend && riot.control.trigger(riot.EVT.updateStationInfobox, this.opts.data)
});



// WEBPACK FOOTER //
// ./src/components/bullet-bar/bullet.tag